<div class="my-5 text-center">
    <h1 class="lead" [translate]="'pages.starting-exercise.in-progress'">
        Starting the exercise
    </h1>
</div>
